<template>
    <el-carousel :interval="10000" type="card" height="700px">
        <el-carousel-item v-for="(item, index) in selectedWidgets"
                          v-if="checkWidgets(item.id)"
                          :key="index"
                          :index="index">
            <component
                :is="item.id"
                v-bind:appearance="appearance"
                v-bind:tenant-id="tenantId"
                v-bind:dashboard-id="dashboard.id"
                class="fin-w-full"
            >
            </component>
        </el-carousel-item>
    </el-carousel>
</template>

<script>
import SubmissionsChart from "../SubmissionsChart";
import SettledChart from "../SetteledChart";
import LeadSettlementChart from "../LeadSettlementChart";
import BrokerSettledChart from "../BrokerSettledChart";
import BrokerNafChart from "../BrokerNafChart";
import BrokerIncomeChart from "../BrokerIncomeChart";
import LenderIncomeChart from "../LenderIncomeChart";
import LenderSettledChart from "../LenderSettledChart";
import LenderNafChart from "../LenderNafChart";
import TeamNafChart from "../TeamNafChart";
import TeamIncomeChart from "../TeamIncomeChart";
import TeamSettledChart from "../TeamSettledChart";
import ActivityChart from "../ActivityChart";
import AverageIncomeChart from "../AverageIncomeChart";
import TotalIncomeChart from "../TotalIncomeChart";
import ClosedApplicationChart from "../ClosedApplicationChart";
import Settlements from "../Settlements";
import SettlementsChart from "../SettlementsChart";
import BrokerBreakdowns from "../BrokerBreakdowns";

export default {
    name: 'DashboardCarousel',
    props: [
        'selectedWidgets',
        'appearance',
        'tenantId',
        'dashboard'
    ],
    components: {
        "submissions-chart": SubmissionsChart,
        "settled-chart": SettledChart,
        "lead-settlement-chart": LeadSettlementChart,
        "broker-settled-chart": BrokerSettledChart,
        "broker-naf-chart": BrokerNafChart,
        "broker-income-chart": BrokerIncomeChart,
        "lender-income-chart": LenderIncomeChart,
        "lender-settled-chart": LenderSettledChart,
        "lender-naf-chart": LenderNafChart,
        "team-settled-chart": TeamSettledChart,
        "team-income-chart": TeamIncomeChart,
        "team-naf-chart": TeamNafChart,
        "activity-chart": ActivityChart,
        "average-income-chart": AverageIncomeChart,
        "total-income-chart": TotalIncomeChart,
        "closed-application-chart": ClosedApplicationChart,
        "settlements": Settlements,
        "settlements-chart": SettlementsChart,
        "broker-breakdowns": BrokerBreakdowns,
    },
    mounted() {
        this.checkWidgets
    },
    created() {
        this.checkWidgets
    },
    methods: {
        checkWidgets(id) {
            return this.selectedWidgets.filter(function (elem) {
                if (_.get(elem, 'id') == id) return elem
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.carousel-3d-container {
}

.carousel-3d-slide {
    border-color: rgba(0, 0, 0, 0.5);
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
}

.el-carousel {
    border: none;
}

.el-carousel__item {
    border: none;
}
</style>
